export enum PageTypes {
  institutions = "institutions",
  classes = "classes",
  labels = "labels",
}
